module.exports = __webpack_public_path__ + "img/mobile-53.ee2fbf59.png";